import type { KeyboardEvent } from 'react';
import type { ClientWithTasks } from '../../types/models';
import { Avatar } from '../Avatar';
import styles from './IdleClientCard.module.css';

interface IdleClientCardProps {
  client: ClientWithTasks;
  onOpen: () => void;
  onAddTask: (title: string) => void;
}

/** Compact, faded tile for a client with no open tasks — parked in the
 *  bottom rail until work is assigned to it. */
export function IdleClientCard({ client, onOpen, onAddTask }: IdleClientCardProps) {
  const projects = client.projects.length;

  const handleAdd = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onAddTask(e.currentTarget.value);
      e.currentTarget.value = '';
    }
  };

  return (
    <div className={styles.card}>
      <button type="button" className={styles.head} onClick={onOpen}>
        <Avatar client={client} size={32} fontSize="0.72rem" />
        <div className={styles.text}>
          <div className={styles.name}>{client.name}</div>
          <div className={styles.meta}>
            {projects} PROJECT{projects === 1 ? '' : 'S'}
          </div>
        </div>
      </button>
      <input
        type="text"
        onKeyDown={handleAdd}
        placeholder="+ add a task…"
        className={styles.add}
        aria-label={`Add a task to ${client.name}`}
      />
    </div>
  );
}
